import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';
import Caption from './caption';
import MainContent from './mainContent';
import Interact from '../../../../../components/interact';
import { getSeoAbDisplay } from '../../../../../../common/seoAbBucket';

class Artical extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string,
        commentInfo: PropTypes.object,
        content: PropTypes.object,
        chipObj: PropTypes.object,
        contentBottomAd: PropTypes.string,
        hasCopyRight: PropTypes.bool,
        faceUrl: PropTypes.string,
        vestAccountDetail: PropTypes.object,
        subscribe: PropTypes.object,
        keywords: PropTypes.string,
        interact: PropTypes.object,
        sourceReason: PropTypes.string,
        isHubeiLocal: PropTypes.bool,
    };

    render() {
        const {
            type,
            commentInfo,
            content,
            chipObj,
            contentBottomAd,
            hasCopyRight,
            faceUrl,
            vestAccountDetail,
            subscribe,
            keywords,
            interact,
            sourceReason,
            isHubeiLocal,
        } = this.props;
        const {
            title,
            newsTime,
            noffhFlag,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            base62Id,
            pcUrl,
            url,
            commentUrl,
            skey,
            voteId,
            isOriginal,
            contentData,
            editorName,
            editorCode,
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            updateTime,
            seoAbValue,
            seoTitle,
            seoDescription,
            quanPlugin,
        } = content;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };
        const { articleTitle, articleSummary } = getSeoAbDisplay({
            title,
            seoAbValue,
            seoTitle,
            seoDescription,
            quanPlugin,
            type,
        });
        const date = newsTime.split(' ')[0];
        const time = newsTime.split(' ')[1];
        const dateTime = `${date.split('-')[0]}年${date.split('-')[1]}月${date.split('-')[2]}日 ${time}`;
        const followUrl = `//gentie.ifeng.com/c/comment/${base62Id}`;
        const captionData = {
            ...commentInfo,
            type,
            title: articleTitle,
            url,
            dateTime,
            noffhFlag,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            commentUrl,
            followUrl,
            pcUrl,
            hasCopyRight,
            faceUrl,
            vestAccountDetail,
            subscribe,
            interact,
            isHubeiLocal,
            updateTime,
            publishTime: newsTime,
        };

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };
        const commentDomain =
            typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        const commentConfig = {
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: `//${commentDomain}/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${commentDomain}/post.php`,
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: `//${commentDomain}/vote.php`,
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: `//${commentDomain}/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            // 是否关闭评论和参与数
            isCloseInteract: isHubeiLocal,
        };
        const isShowEditName = editorCode && (hasCopyRight || sourceReason === '公开信息');

        return (
            <div className={styles.artical}>
                <Caption content={captionData} />
                <MainContent
                    shareInfo={shareInfo}
                    content={contentData}
                    pluginData={pluginData}
                    articleSummary={articleSummary}
                />
                <NoSSR>
                    <div className={styles.artical_line} />
                    <NoSSR>
                        <Chip
                            id={chipObj.contentBottomAd}
                            type="static"
                            title="文章底部推广"
                            groupName="正文"
                            translate="handleAreaAd"
                            content={contentBottomAd}>
                            <AreaStaticChip styleName={contentBottomAd ? styles.chip_box : styles.chip_ebox} />
                        </Chip>
                    </NoSSR>
                    <div className="clear" />
                    <div className={styles.vote_box}>
                        {isShowEditName ? <p className={styles.author}>{`[责任编辑：${editorName}]`}</p> : ''}
                        {isOriginal === '1' || isOriginal === '2' || isOriginal === '3' ? (
                            <p className={styles.copyrightInfo}>(本文章版权归凤凰网所有，未经授权，不得转载)</p>
                        ) : (
                            ''
                        )}
                        <div className="clear" />
                        <Interact
                            isHubeiLocal={isHubeiLocal}
                            keywords={keywords}
                            voteId={voteId}
                            shareInfo={shareInfo}
                            content={interact}
                        />
                    </div>
                    <LazyLoad>
                        <Comment articleInfo={commentConfig} />
                    </LazyLoad>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Artical);
